export default __webpack_public_path__ + "static/media/lf-logo.9fc8fabd.png";